import { useEffect, useState } from "react";
import { api } from "../lib/api";
import {
    Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "./ui/table";
import { History } from "lucide-react";

/**
 * Version history table for a specific legal document.
 * `docKey` is one of: "terms" | "privacy" | "cookies" | "dpa".
 */
export function VersionHistory({ docKey, testId }) {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/legal/versions");
                setRows(data[docKey] || []);
            } catch {
                setRows([]);
            }
        })();
    }, [docKey]);

    if (!rows.length) return null;

    return (
        <section className="border-t border-border py-8" data-testid={testId || `version-history-${docKey}`}>
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-muted-foreground">
                <History className="h-3.5 w-3.5" />
                Version history
            </div>
            <h3 className="mt-2 font-display text-xl font-bold tracking-tight">Changes to this document</h3>
            <p className="mt-2 text-sm text-muted-foreground">
                We keep every published version so partners can reference the exact wording in force when they signed.
            </p>
            <div className="mt-4 border border-border bg-card">
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead className="w-24">Version</TableHead>
                            <TableHead className="w-40">Date</TableHead>
                            <TableHead>Changes</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {rows.map((r) => (
                            <TableRow key={r.version} data-testid={`version-row-${docKey}-${r.version}`}>
                                <TableCell className="font-mono font-semibold text-primary">{r.version}</TableCell>
                                <TableCell className="font-mono text-xs">{r.date}</TableCell>
                                <TableCell className="text-sm text-muted-foreground">{r.changes}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </section>
    );
}
